module.exports = __webpack_public_path__ + "static/media/VectorStroke.c54c446b.svg";